<template>
  <div class="aw-enterprise">
    <div class="com-desc-box">
      <div class="container-center new-box">
        <div class="enterprise-detail">
          <span class="rbtn" @click="goIndex">← 返回</span>
          <p class="etitle">{{ currentDetail.title }}</p>
          <p class="time">{{ currentDetail.updateTime }}</p>
          <div class="normal-text" v-html="currentDetail.content"></div>
        </div>
        <div class="active-list">
          <div class="act-title">
            <span></span>
            最新活动
          </div>
          <ul>
            <li v-for="(item, index) in actives" :key="index" @click="queryAct(item)">
              {{ item.title }}
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {queryNewsDetail, queryActiveList} from '@/api/common.js'

export default {
  data() {
    return {
      actives: [
        { title: "海云捷迅与鼎甲DBackup完成互认证，加强技术协同" },
        { title: "海云捷迅添彩陶都 中国机器人及人工智能大赛宜兴圆满落幕" },
        { title: '第八届集创赛全国总决赛"海云捷迅杯"圆满落幕！' },
        {
          title: '海云捷迅亮相2024中国操作系统产业大会 荣获麒麟软件生态共建"突破创新奖"',
        },
        { title: "海云捷迅携手清华大学：共筑云边融合检测系统" },
      ],
      currentDetail: "",
    };
  },
  methods: {
    queryNews() {
        let {id} = this.$route.query
        queryNewsDetail(id).then(res => {            
            if(res && res.code == 200) {
                this.currentDetail = res.data
            }
        })
    },
    getActiveList() {
        queryActiveList({limit: 5}).then(res => {
            if(res && res.code == 200) {
                this.actives = res.data
            }
            
        })
    },
    extractYearMonthDay(dateString) {
      const date = new Date(dateString);
      // 注意：月份是从0开始计数的，所以需要加1
      const year = date.getFullYear();
      const month = date.getMonth() + 1; // getMonth()返回0-11，因此需要加1
      const day = date.getDate();

      return {
        year: year,
        month: month < 10 ? "0" + month : month, // 确保月份是两位数
        day: day < 10 ? "0" + day : day, // 确保天数是两位数
      };
    },
    truncateString(input) {
      if(!input) return ''
      if (input.length > 93) {
        // 截取前90个字符并添加"..."
        return input.substring(0, 90) + "...";
      } else {
        // 如果字符串不超过93个字符，则直接返回原字符串
        return input;
      }
    },
    queryAct(val) {
        this.$router.push({ name: 'enterpriseDetail', query: { id: val.id } });
    },
    goIndex() {
        this.$router.push({name: 'enterprise'})
    },
  },
  mounted() {
    this.queryNews()
    this.getActiveList()
  },
  watch: {
    $route() {
      this.queryNews()
    }
  },
  beforeRouteEnter(to, from, next) {
    next(() => {
      // 进入组件后滚动到顶部
      window.scrollTo(0, 0)
    })
  }
};
</script>